// Assistant shortcuts for the Shortcuts dialog: Enter asks, Shift+Enter adds a line, Esc stops the answer being written.
import type { ShortcutDef } from "@/app/shortcuts";

export const ASSISTANT_SHORTCUTS: readonly ShortcutDef[] = [
  { id: "assistant-send", keys: [["Enter"]], description: "Ask the question" },
  { id: "assistant-newline", keys: [["Shift", "Enter"]], description: "New line in the question" },
  { id: "assistant-stop", keys: [["Esc"]], description: "Stop the answer being written" },
];
